/**
 * @file Footer.jsx
 * @description Footer section with navigation links and contact information.
 */

import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Home', href: '/', isRoute: true },
    { label: 'Who We Are', href: '/#who-we-are', isRoute: false },
    { label: 'What We Do', href: '/#what-we-do', isRoute: false },
    { label: 'Our Approach', href: '/our-approach', isRoute: true },
    { label: 'Work with Us', href: '/work-with-us', isRoute: true },
    { label: 'Blog', href: '/blog', isRoute: true },
    { label: 'Contact', href: '/#contact', isRoute: false },
  ];

  return (
    <div id="footer">
      <section>
        <Container>
          <Row className="footer-content">
            <Col md={4} className="mb-4 mb-md-0">
              <h5 className="footer-title">Bellefy Insights</h5>
              <p className="footer-description">
                Implementation-Led Data & Decision Intelligence
              </p>
              <p className="footer-tagline">
                Turning complex, fragmented data into decision-ready intelligence.
              </p>
            </Col>

            <Col md={4} className="mb-4 mb-md-0">
              <h5 className="footer-title">Quick Links</h5>
              <ul className="footer-links">
                {quickLinks.map(({ label, href, isRoute }) => (
                  <li key={label}>
                    {isRoute ? (
                      <Link to={href}>{label}</Link>
                    ) : (
                      <a href={href}>{label}</a>
                    )}
                  </li>
                ))}
              </ul>
            </Col>

            <Col md={4}>
              <h5 className="footer-title">Contact Us</h5>
              <div className="footer-contact">
                <p>
                  <a href="https://www.bellefyinsights.org" target="_blank" rel="noopener noreferrer">
                    www.bellefyinsights.org
                  </a>
                </p>
                <p>
                  <a href="mailto:contact@bellefyinsights.com">
                    contact@bellefyinsights.com
                  </a>
                </p>
                <p>
                  <a href="https://www.linkedin.com/company/bellefy-insights" target="_blank" rel="noopener noreferrer" aria-label="Bellefy Insights on LinkedIn">
                    LinkedIn
                  </a>
                </p>
              </div>
            </Col>
          </Row>

          <hr className="footer-divider" />

          <div className="copyright">
            <p>&copy; {currentYear} Bellefy Insights. All rights reserved.</p>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default Footer;
